module.exports = __webpack_public_path__ + "assets/images/25Box.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25Box.png
// module id = 1292
// module chunks = 1